import React, { createContext, useContext, useEffect, useState } from 'react';
import supabase from '../supabase/supabase';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('light'); // Default to light

  useEffect(() => {
    // Fetch initial global theme from DB
    const fetchTheme = async () => {
      try {
        const { data, error } = await supabase
          .from('site_settings')
          .select('theme')
          .eq('id', 1)
          .single();
          
        if (data && !error) {
          setTheme(data.theme);
        }
      } catch (err) {
        console.error("Error fetching theme:", err);
      }
    };

    fetchTheme();

    // Listen for real-time global theme changes
    const subscription = supabase
      .channel('public:site_settings')
      .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'site_settings' }, (payload) => {
        if (payload.new && payload.new.theme) {
          setTheme(payload.new.theme);
        }
      })
      .subscribe();

    return () => {
      supabase.removeChannel(subscription);
    };
  }, []);

  // Apply theme class to document
  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
      document.documentElement.classList.remove('light');
    } else {
      document.documentElement.classList.add('light');
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  // Admin function to update the global theme
  const updateGlobalTheme = async (newTheme) => {
    setTheme(newTheme);
    try {
      await supabase
        .from('site_settings')
        .update({ theme: newTheme, updated_at: new Date().toISOString() })
        .eq('id', 1);
    } catch (err) {
      console.error("Error updating global theme:", err);
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, updateGlobalTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);